import React, { useRef } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import BootstrapTable from "src/components/BootstrapTable";
import DeleteButton from "src/components/DeleteButton";
import DetailButton from "src/components/DetailButton";
import EditButton from "src/components/EditButton";
import Title from "src/components/Title";
import API from "src/services/api";
import TableFormatter from "src/utils/tableFormatter";

const SwipeOverviewSite = () => {
  const navigate = useNavigate();
  const table = useRef();

  const deleteSwipe = async (swipe_id) => {
    if (window.confirm("Swipe löschen?")) {
      await API.deleteSwipe(swipe_id);
      table.current.refresh();
    }
  };

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Title>Swipe-Übersicht</Title>
        </Col>
      </Row>
      <Row className="add-margin">
        <Col className="text-end">
          <Button variant="default" onClick={() => navigate(`/swipe/add`)}>
            Neuer Swipe
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <BootstrapTable
            url="/api/backend/swipes"
            sort="updated_at"
            order="desc"
            ref={table}
            showSearch
            showClear
            showRefresh
            showFilter
            cache
            pageSize={25}
            pageSizes={[25, 50, 100, 250]}
            columns={[
              {
                field: "source",
                name: "Quelle",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "status",
                name: "Status",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "swipetype_name",
                name: "Swipe-Typ",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "name",
                name: "Name",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "street",
                name: "Strasse",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "street_no",
                name: "Nr",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "postcode",
                name: "PLZ",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "city",
                name: "Stadt",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "zefix_id",
                name: "ZEFIX-ID",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "zefix_name",
                name: "ZEFIX Name",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "website",
                name: "Webseite",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "has_medias",
                name: "Bild",
                formatter: TableFormatter.formatBoolean,
              },
              {
                field: "has_business_hours",
                name: "ÖZ",
                formatter: TableFormatter.formatBoolean,
              },
              {
                field: "sino_popularity_score",
                name: "Score",
                sortable: false,
              },
              {
                field: "updated_at",
                name: "Letzte Änderung",
                sortable: true,
                formatter: TableFormatter.formatDateTime,
              },
              {
                field: "checked_at",
                name: "Letzte Überprüfung",
                sortable: true,
                formatter: TableFormatter.formatDateTime,
              },
              {
                field: "id",
                textAlign: "right",
                width: 120,
                formatter: (value) => {
                  return (
                    <React.Fragment>
                      <DetailButton url={`/swipe/${value}`} />{" "}
                      <EditButton url={`/swipe/edit/${value}`} />{" "}
                      <DeleteButton onClick={() => deleteSwipe(value)} />
                    </React.Fragment>
                  );
                },
              },
            ]}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default SwipeOverviewSite;
